module.exports = __webpack_public_path__ + "img/weddings_01_V.f62588bd.webp";